import { worldData } from "../seed";
import type { Airspace, Airport, MarketDemand, WorldData } from "../types";

export function getWorldData(): WorldData {
  return worldData;
}

export function airportByCode(code: string, world: WorldData = worldData) {
  const value = code.trim().toUpperCase();
  return world.airports.find((airport) => airport.code === value || airport.icao === value);
}

export function requireAirport(code: string, world: WorldData = worldData): Airport {
  const airport = airportByCode(code, world);
  if (!airport) {
    throw new Error(`airport not found: ${code}`);
  }
  return airport;
}

export function resolveAirportCode(input: string, world: WorldData = worldData): string {
  return requireAirport(input, world).code;
}

export function aircraftTypeById(id: string, world: WorldData = worldData) {
  return world.aircraftTypes.find((type) => type.id === id);
}

export function regionById(id: string, world: WorldData = worldData) {
  return world.regions.find((region) => region.id === id);
}

export function fuelZoneById(id: string, world: WorldData = worldData) {
  return world.fuelZones.find((zone) => zone.id === id);
}

export function marketBetween(originRegionId: string, destinationRegionId: string, world: WorldData = worldData): MarketDemand | undefined {
  return world.markets.find((market) => {
    return (
      (market.originRegionId === originRegionId && market.destinationRegionId === destinationRegionId) ||
      (market.originRegionId === destinationRegionId && market.destinationRegionId === originRegionId)
    );
  });
}

export function airspacesForRoute(origin: Airport, destination: Airport, world: WorldData = worldData): Airspace[] {
  return world.airspaces.filter((airspace) => {
    const touchesOrigin = airspace.regionIds.includes(origin.regionId);
    const touchesDestination = airspace.regionIds.includes(destination.regionId);
    return touchesOrigin || touchesDestination;
  });
}
